import Reveal from "react-reveal/Reveal";
import { WorkWithUsContent } from "./WorkWithUsContent";
import { useMediaQuery } from "react-responsive";

import { Container, Content, Photo } from "./styles";

export function WorkWithUs() {
  const isDesktop = useMediaQuery({ query: "(min-width: 949px)" });
  const isBigDesktop = useMediaQuery({ query: "(min-width: 1200px)" });
  return (
    <Reveal>
      <Container desktop={isDesktop}>
        <Content big={isBigDesktop}>
          <WorkWithUsContent />
        </Content>
        <Photo src="img/work-with-us.png" alt="" />
      </Container>
    </Reveal>
  );
}
